module.exports = __webpack_public_path__ + "static/media/t-2-q-10-2.b6df611c.png";